var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c("MainHeader", { attrs: { title: "현장 접수 화면" } }),
      _c(
        "section",
        [
          _c("section", { staticClass: "external" }, [
            _vm.group != undefined && _vm.group != null
              ? _c("div", { staticClass: "external_box" }, [
                  _c("div", { staticClass: "content_title" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.event.event_nm))]),
                    _c("h3"),
                    _vm._m(0),
                    _vm.cartList.length > 0
                      ? _c(
                          "ul",
                          { staticClass: "external_thumb_list" },
                          _vm._l(_vm.cartList, function(goods) {
                            return _c("li", { key: goods.good_no }, [
                              _c("a", { attrs: { href: "#" } }, [
                                _c("div", { staticClass: "thumb" }, [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.$store.getters[
                                          "systemStore/getImgPath"
                                        ] + goods.img_path,
                                      alt: goods.good_nm
                                    }
                                  })
                                ])
                              ])
                            ])
                          }),
                          0
                        )
                      : _c("ul", [_vm._v(" 등록된 상품이 없습니다. ")])
                  ]),
                  _c("div", { staticClass: "content_content" }, [
                    _c("ul", { staticClass: "question_list" }, [
                      _c("li", [
                        _c("label", { staticClass: "question" }, [
                          _vm._v("이름")
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.group.cell_nm,
                              expression: "group.cell_nm"
                            }
                          ],
                          attrs: {
                            type: "text",
                            placeholder: "이름을 입력해주세요.",
                            maxlength: "30"
                          },
                          domProps: { value: _vm.group.cell_nm },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.group,
                                "cell_nm",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _c("li", [
                        _c("label", { staticClass: "question" }, [
                          _vm._v("전화번호")
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.group.recvr_cell,
                              expression: "group.recvr_cell"
                            }
                          ],
                          attrs: {
                            type: "tel",
                            maxlength: "13",
                            placeholder: "-없이 입력하세요."
                          },
                          domProps: { value: _vm.group.recvr_cell },
                          on: {
                            keyup: _vm.setCellForm,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.group,
                                "recvr_cell",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "input-form-checkbox txt-center" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checked,
                          expression: "checked"
                        }
                      ],
                      attrs: { type: "checkbox", id: "rul-agree" },
                      domProps: {
                        checked: Array.isArray(_vm.checked)
                          ? _vm._i(_vm.checked, null) > -1
                          : _vm.checked
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checked = $$c
                          }
                        }
                      }
                    }),
                    _vm._m(1)
                  ]),
                  _c(
                    "button",
                    { staticClass: "btn_large", on: { click: _vm.save } },
                    [_vm._v("저 장")]
                  )
                ])
              : _c("div", { staticClass: "external_box" }, [
                  _c("div", { staticClass: "content_title" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.event.event_nm))]),
                    _vm._m(2)
                  ]),
                  _vm._m(3)
                ])
          ]),
          _c("Footer", { staticStyle: { background: "#fafafa" } })
        ],
        1
      ),
      _c("div", { staticClass: "popup scene_01" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _c("div", { staticClass: "popup_content" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
          ]),
          _vm._m(4)
        ]),
        _c("div", { staticClass: "dimBg" })
      ]),
      _c("div", { staticClass: "popup scene_02" }, [
        _c("div", { staticClass: "popup_container" }, [
          _c("header", { staticClass: "popup_header" }, [_vm._v("안 내")]),
          _c("div", { staticClass: "popup_content" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })
          ]),
          _vm._m(5)
        ]),
        _c("div", { staticClass: "dimBg" })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "caption" }, [
      _vm._v(" 바쁘신 와중에 어려운 걸음 해주셔서 감사합니다."),
      _c("br"),
      _vm._v(" 감사의 의미로 조그마한 선물을 준비했습니다."),
      _c("br"),
      _vm._v(
        " 아래 정보를 입력해 주시면, 선물을 수령할 수 있는 링크를 전송해 드립니다."
      ),
      _c("br"),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "rul-agree" } }, [
      _c("i", { staticClass: "xi-check-min" }),
      _vm._v("문자 발송을 위한 개인 정보의 이용에 동의합니다. "),
      _c("br"),
      _c("span", { staticClass: "sub" }, [
        _vm._v("(개인정보 위탁 처리 : 삼성웰스토리 주식회사) ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("p", { staticClass: "caption" }, [
        _c("br"),
        _c("br"),
        _c("br"),
        _c("br"),
        _c("br"),
        _c("br"),
        _vm._v(" 현장접수 그룹이 등록되어 있지 않아"),
        _c("br"),
        _vm._v(" 해당 서비스를 이용하실 수 없습니다. ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_content" }, [
      _c("br"),
      _c("br"),
      _c("br"),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_button" }, [
      _c(
        "button",
        { staticClass: "btn_large", attrs: { onclick: "modal('scene_01')" } },
        [_vm._v("확 인")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_button" }, [
      _c(
        "button",
        { staticClass: "btn_large", attrs: { onclick: "location.reload();" } },
        [_vm._v("확 인")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }